import React from 'react'
import { Link } from 'react-router-dom'
import { usuariosAPI } from '../../utils/funcionesAPI'
import { validateEmail } from '../../utils/Tools'
import {manejadorDeRespuesta} from '../../utils/Tools'
import {toast, ToastContainer} from 'react-toastify';

//FC: stateless componente (sin estado, solo con props)
export const IniciarRecuperoPassword = (props) => {

  function enviarMail(e) {
    e.preventDefault();

    if (!validateEmail(e.target.parentNode.parentNode[0].value)) {
      toast.info('Debe completar un email', {
                position: toast.POSITION.BOTTOM_CENTER
                });

    } else {

      let data = JSON.stringify({accion: 'recuperoPassword', email: e.target.parentNode.parentNode[0].value});
      toast.info('Enviando Mail. Aguarde unos instantes por favor.', {
                position: toast.POSITION.BOTTOM_CENTER
                });
      usuariosAPI(data).then(respuesta => {
          if (manejadorDeRespuesta(props, respuesta)) {
              toast.success(respuesta.data, {
                        position: toast.POSITION.BOTTOM_CENTER,
                        onClose: () =>  props.history.push('/')
                        });
            }
      });
    }
  }

  return (
    <section className="checkout-steps">
      <div className="container">
        <div className="row">
          <div className="content col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12">
      <div className="title">
        <h2>Recuperar Password</h2>
        <hr />
      </div>
      <form className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 login">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text"><i className="material-icons">email</i></span>
          </div>
          <input type="email" name="email" id="mail" placeholder="Ingrese su mail" onChange={this.handleLoginChange} />
        </div>

        <div className="input-group">
          <div className="options">
            <Link to={'/registracion'}>Crear nuevo usuario</Link>
            <Link to={'/login'}>Login</Link>
          </div>
          <input type="submit" value="Recuperar" onClick={enviarMail} />
        </div>
      </form>
        <div className="listado">
          <Link to='/'>Volver al inicio</Link>
        </div>
      </div>
    </div>
   </div>
   <ToastContainer />
   </section>


  )
}


export const ActivarPassword = (props) => {

  const {codigoValidacion, idUsuarioWeb} = props.match.params;

  function actualizarPassword(e) {
    e.preventDefault();

    if (e.target.parentNode.parentNode[0].value.length <= 3 || e.target.parentNode.parentNode[0].value.length > 8) {
      toast.info('Debe completar una clave valida', {
                position: toast.POSITION.BOTTOM_CENTER
                });
      return;
    } else {
      let data = JSON.stringify({accion: 'actualizarPassword', codigoActivacion: codigoValidacion, idUsuarioWeb: idUsuarioWeb,
        password: e.target.parentNode.parentNode[0].value});

        usuariosAPI(data).then(respuesta => {
            if (manejadorDeRespuesta(props, respuesta)) {
                toast.info(respuesta.data, {
                          position: toast.POSITION.BOTTOM_CENTER,
                          onClose: () =>  props.history.push('/')
                          });
            }
        });
    }


    }

    return (
      <section className="checkout-steps">
        <div className="container">
          <div className="row">
            <div className="content col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12">
        <div className="title">
          <h2>Actualizar Password</h2>
          <hr />
          <p>Debe tener entre 4 y 8 carácteres</p>
        </div>
        <form className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 login">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text"><i className="material-icons">lock</i></span>
            </div>
            <input type="password" name="password" placeholder="Ingrese su nueva clave" />
          </div>

          <div className="input-group">
            <div className="options">
              <Link to={'/registracion'}>Crear nuevo usuario</Link>
              <Link to={'/login'}>Login</Link>
            </div>
            <input type="submit" value="Actualizar" onClick={actualizarPassword} />
          </div>
        </form>
          <div className="listado">
            <Link to='/'>Volver al inicio</Link>
          </div>
        </div>
      </div>
     </div>
     <ToastContainer />
     </section>
    )
    }



// WEBPACK FOOTER //
// ./src/components/RecuperoPassword/index.js